// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedParagraphStyle {
  Expressions: {"enum_constant":"Expressions"};
  OrderedList: {"enum_constant":"OrderedList"};
  Plain: {"enum_constant":"Plain"};
  Poem: {"enum_constant":"Poem"};
  Tip: {"enum_constant":"Tip"};
  UnorderedList: {"enum_constant":"UnorderedList"};
}

export type ParagraphStyleId = keyof IParsedParagraphStyle;
export type ParagraphStyleData = IParsedParagraphStyle[ParagraphStyleId];
const data: ParagraphStyleData[] = [{"enum_constant":"Expressions"},{"enum_constant":"OrderedList"},{"enum_constant":"Plain"},{"enum_constant":"Poem"},{"enum_constant":"Tip"},{"enum_constant":"UnorderedList"}];
export default data;
